Postlogin.Admin = Postlogin.Admin || {};
Postlogin.Admin.Lessons = Postlogin.Admin.Lessons || {};
Postlogin.Admin.Lessons.Pages = Postlogin.Admin.Lessons.Pages || {};

// TODO: This is namespacing mess - we need to figure out a better way to do this.
Postlogin.Admin.Lessons.Pages.Segments = (function () {
    let initialSegmentType = null;

    const init = function () {
        initialSegmentType = $('#segment_type_id').val();

        $('.segment-content').hide();
        $(`#segment-content-${CSS.escape(initialSegmentType)}`).show();

        // show the correct fields per segment type
        $('#segment_type_id').on('change', function () {
            const value = $(this).val();
            $('.segment-content').hide();
            $(`#segment-content-${CSS.escape(value)}`).show();
        });

        if ($('.video-closed-captions').length) {
            $('.video-closed-captions').on('click', '.add-row', (e) => {
                e.preventDefault();
                const $row = $('<tr></tr>').html($('#caption-row-template').html());
                $row.find('input,textarea,select').val('');
                $row.appendTo($('.closed-captions-table tbody'));
            });
            $('.video-closed-captions').on('click', '.remove-row', function (e) {
                e.preventDefault();
                $(this).closest('tr').remove();
            });
            $('.video-closed-captions').on('click', '.clear-all', (e) => {
                e.preventDefault();
                $('.closed-captions-table tbody tr:not(#caption-row-template)').remove();
            });

            $('.video-closed-captions').on('click', '.json-export', (e) => {
                e.preventDefault();
                const filename = window.prompt('File name? ', 'video-captions.json');
                const data = getCaptionData();
                const string = JSON.stringify(data);
                const blob = new Blob([string], {
                    type: 'text/plain;charset=utf-8',
                });
                saveAs(blob, filename);
            });

            $('.video-closed-captions').on('click', '.srt-export', (e) => {
                e.preventDefault();
                const filename = window.prompt('File name? ', 'video-captions.srt');
                const data = getCaptionData();
                let output = '';

                $(data).each((i, caption) => {
                    output += `${i + 1}\n`;
                    output += `${formatTimeForSRT(caption.begin_time)} --> ${formatTimeForSRT(caption.end_time)}\n`;
                    output += `${caption.text}\n\n`;
                });

                const blob = new Blob([output], {
                    type: 'text/plain;charset=utf-8',
                });

                saveAs(blob, filename);
            });

            $('.video-closed-captions').on('change', ':file', function () {
                const file = $(this).get(0).files[0];
                const type = file.name.split('.').pop();
                let captions = null;

                switch (type) {
                    case 'srt': {
                        const reader = new FileReader();
                        reader.onload = function () {
                            const rawData = this.result;
                            captions = parseSRT(rawData);
                            addSRTCaptions(captions);
                        };
                        reader.readAsText(file, 'UTF-8');
                        break;
                    }
                    case 'json': {
                        const reader = new FileReader();
                        reader.onload = function () {
                            const rawData = this.result;
                            captions = JSON.parse(rawData);
                            addJSONCaptions(captions);
                        };
                        reader.readAsText(file, 'UTF-8');
                        break;
                    }
                    case 'txt': {
                        const reader = new FileReader();
                        reader.onload = function () {
                            const rawData = this.result;
                            captions = parseLabels(rawData);
                            addJSONCaptions(captions);
                        };
                        reader.readAsText(file, 'UTF-8');
                        break;
                    }
                    default:
                        break;
                }

                // reset the file upload field value, so we can re-upload the same
                // file more than once if we want.
                $(this)[0].value = '';
            });
        }
    };

    const parseLabels = function (rawData) {
        const lines = rawData.split(/\n/);
        const captions = [];
        $(lines).each((i, line) => {
            if (line !== '') {
                const caption = {};
                const parts = line.split(/\t/);
                caption.begin_time = Math.round(parts[0] * 1000);
                caption.end_time = Math.round(parts[1] * 1000);
                // eslint-disable-next-line prefer-destructuring
                caption.text = parts[2];
                captions.push(caption);
            }
        });

        return captions;
    };

    const getCaptionData = function () {
        const data = [];
        $('.closed-captions-table tbody tr:not(#caption-row-template)').each(function () {
            const caption = {};
            caption.begin_time = $(this).find('.begin_time').val();
            caption.end_time = $(this).find('.end_time').val();
            caption.character = $(this).find('.character').val();
            caption.position = $(this).find('.position').val();
            caption.text = $(this).find('.text').val();
            caption.text_es = $(this).find('.text_es').val();
            data.push(caption);
        });

        return data;
    };

    // converts milliseconds to an SRT time format (00:00:00,000)
    const formatTimeForSRT = function (time) {
        let millis = parseInt(time / 1000, 10);
        const seconds = millis % 60;
        millis = parseInt(millis / 60, 10);
        const minutes = millis % 60;
        millis = parseInt(millis / 60, 10);
        const hours = millis % 24;
        const out = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')},${String(
            hours,
        ).padStart(3, '0')}`;

        return out.trim();
    };

    const addSRTCaptions = function (captions) {
        $(captions).each((i, caption) => {
            const $row = $('<tr></tr>').html($('#caption-row-template').html());
            $row.find('input,textarea,select').val('');
            $row.find('.begin_time').val(Math.round(caption.start * 1000));
            $row.find('.end_time').val(Math.round(caption.end * 1000));

            const regex = /<br\s*[/]?>/gi;

            $row.find('.text').val(caption.text.replace(regex, '\n'));
            $row.appendTo($('.closed-captions-table tbody'));
        });
    };

    const addJSONCaptions = function (captions) {
        $(captions).each((i, caption) => {
            const $row = $('<tr></tr>').html($('#caption-row-template').html());
            $row.find('input,textarea,select').val('');
            $row.find('.begin_time').val(caption.begin_time);
            $row.find('.end_time').val(caption.end_time);
            $row.find('.character').val(caption.character);
            $row.find('.position').val(caption.position);
            $row.find('.text').val(caption.text);
            $row.find('.text_es').val(caption.text_es);
            $row.appendTo($('.closed-captions-table tbody'));
        });
    };

    return {
        init,
    };
}());
